import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_2 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_3 = {
  class: "data-table-shell"
};
const _hoisted_4 = {
  class: "data-table-scroll"
};
const _hoisted_5 = {
  class: "data-table text-sm"
};
const _hoisted_6 = {
  class: "data-table-td"
};
const _hoisted_7 = {
  class: "text-sm font-medium text-slate-800 break-all"
};
const _hoisted_8 = {
  class: "data-table-td"
};
const _hoisted_9 = ["title", "onClick"];
const _hoisted_10 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_11 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_12 = {
  class: "data-table-td"
};
const _hoisted_13 = ["title"];
const _hoisted_14 = {
  class: "data-table-td is-center whitespace-nowrap"
};
const _hoisted_15 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  key: 0,
  class: "empty-state"
};
const _hoisted_21 = {
  key: 1,
  class: "flex items-center justify-center py-12"
};
const _hoisted_22 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
};
const _hoisted_23 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_24 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3 shrink-0"
};
const _hoisted_25 = ["disabled"];
import { ref, computed, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useUserStore } from '@/stores/user';
import { meetingApi } from '@/api/meeting';
import { formatDateTime } from '@/utils/dateFormat';
import AppModal from '@/components/AppModal.vue';
import AppPagination from '@/components/AppPagination.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
export default {
  __name: 'MyActionItemList',
  emits: ['open-meeting'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;

    // 状态徽章颜色映射（文案直接使用后端 statusDesc 字段）
    const ACTION_STATUS_CLASS = {
      PENDING: 'is-neutral',
      IN_PROGRESS: 'is-info',
      DONE: 'is-success',
      CANCELLED: 'is-danger'
    };

    // 列表数据
    const loading = ref(false);
    const records = ref([]);
    const pagination = ref({
      current: 1,
      size: 10,
      total: 0,
      pages: 0
    });

    // 筛选条件
    const searchKeyword = ref('');
    const filterStatus = ref('');

    // 写进展弹窗状态
    const showProgressModal = ref(false);
    const progressItem = ref(null);
    const progressNote = ref('');
    const savingProgress = ref(false);

    // 归属判断：流转/进展仅负责人本人可见（/mine 接口本就只返回本人的，显式判断作防御）
    const userStore = useUserStore();
    const currentUserId = computed(() => userStore.userInfo?.userId);
    const isAssignee = row => {
      if (currentUserId.value == null) return false;
      return Number(row.assigneeId) === Number(currentUserId.value);
    };

    // 拉取我的决策项（服务端注入当前用户）
    const fetchList = async () => {
      loading.value = true;
      try {
        const params = {
          page: pagination.value.current,
          size: pagination.value.size,
          keyword: searchKeyword.value || undefined,
          status: filterStatus.value || undefined
        };
        Object.keys(params).forEach(key => {
          if (params[key] === undefined) delete params[key];
        });
        const data = await meetingApi.getMyActionItemList(params);
        records.value = data?.records || [];
        pagination.value = {
          current: Number(data?.current) || 1,
          size: Number(data?.size) || 10,
          total: Number(data?.total) || 0,
          pages: Number(data?.pages) || 0
        };
      } catch (error) {
        ElMessage.error('获取我的决策项失败');
        console.error('获取我的决策项失败:', error);
      } finally {
        loading.value = false;
      }
    };

    // 加载时机：父组件用 v-if 控制挂载，仅在 Tab 激活时挂载并加载
    onMounted(fetchList);
    const handleSearch = () => {
      pagination.value.current = 1;
      fetchList();
    };
    const handleReset = () => {
      searchKeyword.value = '';
      filterStatus.value = '';
      pagination.value.current = 1;
      fetchList();
    };
    const handlePageChange = page => {
      pagination.value.current = page;
      fetchList();
    };
    const handlePageSizeChange = size => {
      pagination.value.size = size;
      pagination.value.current = 1;
      fetchList();
    };

    // 点击所属会议，通知父组件打开会议详情抽屉
    const handleOpenMeeting = row => {
      if (!row.meetingId) return;
      emit('open-meeting', row.meetingId);
    };

    // 逾期判断：未完成（PENDING/IN_PROGRESS）且截止时间早于当前
    const isOverdue = row => {
      if (!row.deadline) return false;
      if (row.status !== 'PENDING' && row.status !== 'IN_PROGRESS') return false;
      const deadline = new Date(String(row.deadline).replace(' ', 'T'));
      return deadline.getTime() < Date.now();
    };

    // 状态流转（与 ActionItemPanel 一致；confirm 取消时静默忽略）
    const handleTransit = async (row, status) => {
      const actionText = {
        IN_PROGRESS: '开始处理',
        DONE: '完成',
        CANCELLED: '取消'
      }[status];
      try {
        await ElMessageBox.confirm(`确认${actionText}决策项「${row.title}」？`, '提示', {
          type: 'warning'
        });
        await meetingApi.updateActionItemStatus(row.id, {
          status
        });
        ElMessage.success('操作成功');
        fetchList();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('决策项状态流转失败:', error);
        }
      }
    };

    // 打开写进展弹窗
    const handleOpenProgress = row => {
      progressItem.value = row;
      progressNote.value = row.progressNote || '';
      showProgressModal.value = true;
    };

    // 保存进展
    const handleSaveProgress = async () => {
      if (!progressNote.value?.trim()) {
        ElMessage.warning('请输入进展说明');
        return;
      }
      savingProgress.value = true;
      try {
        await meetingApi.updateActionItemProgress(progressItem.value.id, {
          progressNote: progressNote.value.trim()
        });
        ElMessage.success('进展已保存');
        showProgressModal.value = false;
        fetchList();
      } catch (error) {
        // 错误已由拦截器提示
        console.error('保存进展失败:', error);
      } finally {
        savingProgress.value = false;
      }
    };
    __expose({
      fetchList
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(PageFilterBar, {
        "shell-class": "filter-bar-shell is-embedded",
        "body-class": "filter-bar-body is-panel",
        "show-refresh": true,
        "refresh-loading": loading.value,
        onRefresh: fetchList
      }, {
        searchActions: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: handleSearch
        }, "搜索"), _createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: handleReset
        }, "重置")]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
          type: "text",
          placeholder: "搜索决策项标题",
          class: "form-search-input form-control-sm w-full",
          onKeyup: _withKeys(handleSearch, ["enter"])
        }, null, 544), [[_vModelText, searchKeyword.value]]), _cache[6] || (_cache[6] = _createElementVNode("svg", {
          class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        })], -1))]), _createVNode(_component_el_select, {
          modelValue: filterStatus.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filterStatus.value = $event),
          placeholder: "全部状态",
          class: "form-select form-control-sm filter-bar-field",
          onChange: handleSearch
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "全部状态",
            value: ""
          }), _createVNode(_component_el_option, {
            label: "待处理",
            value: "PENDING"
          }), _createVNode(_component_el_option, {
            label: "进行中",
            value: "IN_PROGRESS"
          }), _createVNode(_component_el_option, {
            label: "已完成",
            value: "DONE"
          }), _createVNode(_component_el_option, {
            label: "已取消",
            value: "CANCELLED"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("table", _hoisted_5, [_cache[11] || (_cache[11] = _createElementVNode("thead", {
        class: "data-table-head"
      }, [_createElementVNode("tr", null, [_createElementVNode("th", {
        class: "data-table-th text-left"
      }, "标题"), _createElementVNode("th", {
        class: "data-table-th text-left w-48"
      }, "所属会议"), _createElementVNode("th", {
        class: "data-table-th text-left w-40"
      }, "截止时间"), _createElementVNode("th", {
        class: "data-table-th text-left w-24"
      }, "状态"), _createElementVNode("th", {
        class: "data-table-th text-left w-48"
      }, "最新进展"), _createElementVNode("th", {
        class: "data-table-th text-center w-32"
      }, "操作")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, row => {
        return _openBlock(), _createElementBlock("tr", {
          key: row.id,
          class: "data-table-row"
        }, [_createElementVNode("td", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(row.title), 1)]), _createElementVNode("td", _hoisted_8, [_createElementVNode("button", {
          type: "button",
          class: "text-sm text-primary-600 hover:text-primary-700 hover:underline break-all text-left",
          title: row.meetingTitle || '',
          onClick: $event => handleOpenMeeting(row)
        }, _toDisplayString(row.meetingTitle || '-'), 9, _hoisted_9)]), _createElementVNode("td", _hoisted_10, [_createElementVNode("span", {
          class: _normalizeClass(isOverdue(row) ? 'text-sm font-medium text-red-600' : 'text-sm text-slate-600')
        }, _toDisplayString(_unref(formatDateTime)(row.deadline) || '-'), 3)]), _createElementVNode("td", _hoisted_11, [_createElementVNode("span", {
          class: _normalizeClass(['status-badge', ACTION_STATUS_CLASS[row.status] || 'is-neutral'])
        }, _toDisplayString(row.statusDesc || row.status), 3)]), _createElementVNode("td", _hoisted_12, [_createElementVNode("p", {
          class: "max-w-48 truncate text-sm text-slate-600",
          title: row.progressNote || ''
        }, _toDisplayString(row.progressNote || '-'), 9, _hoisted_13)]), _createElementVNode("td", _hoisted_14, [_createElementVNode("div", _hoisted_15, [row.meetingStatus === 'PLANNED' && row.status === 'PENDING' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [isAssignee(row) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "table-action-button is-success",
          title: "开始处理",
          "aria-label": "开始处理",
          onClick: $event => handleTransit(row, 'IN_PROGRESS')
        }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
        }), _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        })], -1)]))], 8, _hoisted_16)) : _createCommentVNode("", true), isAssignee(row) ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "table-action-button is-primary",
          title: "完成",
          "aria-label": "完成",
          onClick: $event => handleTransit(row, 'DONE')
        }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 13l4 4L19 7"
        })], -1)]))], 8, _hoisted_17)) : _createCommentVNode("", true)], 64)) : row.meetingStatus === 'PLANNED' && row.status === 'IN_PROGRESS' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [isAssignee(row) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "table-action-button is-primary",
          title: "完成",
          "aria-label": "完成",
          onClick: $event => handleTransit(row, 'DONE')
        }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 13l4 4L19 7"
        })], -1)]))], 8, _hoisted_18)) : _createCommentVNode("", true), isAssignee(row) ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "table-action-button is-indigo",
          title: "写进展",
          "aria-label": "写进展",
          onClick: $event => handleOpenProgress(row)
        }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
        })], -1)]))], 8, _hoisted_19)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])])]);
      }), 128))])])])]), records.value.length === 0 && !loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[12] || (_cache[12] = [_createElementVNode("p", {
        class: "empty-state-title"
      }, "暂无决策项", -1)]))])) : _createCommentVNode("", true), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
        class: "w-8 h-8 animate-spin text-primary-500",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      })], -1)]))])) : _createCommentVNode("", true), pagination.value.pages > 1 ? (_openBlock(), _createBlock(AppPagination, {
        key: 2,
        class: "pagination-bridge",
        pagination: pagination.value,
        "page-sizes": [10, 20, 50],
        onPageChange: handlePageChange,
        onSizeChange: handlePageSizeChange
      }, null, 8, ["pagination"])) : _createCommentVNode("", true), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: showProgressModal.value,
          size: "sm",
          onClose: _cache[5] || (_cache[5] = $event => showProgressModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_cache[15] || (_cache[15] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "写进展", -1)), _createElementVNode("button", {
            type: "button",
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer",
            onClick: _cache[2] || (_cache[2] = $event => showProgressModal.value = false)
          }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_23, [_cache[16] || (_cache[16] = _createElementVNode("label", {
            class: "form-label"
          }, "进展说明", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => progressNote.value = $event),
            rows: "4",
            placeholder: "请输入最新进展",
            class: "form-textarea"
          }, null, 512), [[_vModelText, progressNote.value]])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[4] || (_cache[4] = $event => showProgressModal.value = false)
          }, " 取消 "), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: savingProgress.value,
            onClick: handleSaveProgress
          }, _toDisplayString(savingProgress.value ? '保存中...' : '保存'), 9, _hoisted_25)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]))]);
    };
  }
};